<template>
  <el-dialog
    :visible.sync="dialogVisible"
    custom-class="jwt-satisfaction-dialog"
    width="710px"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="!submitting"
    append-to-body
    @close="handleClose"
  >
    <button class="jwt-satisfaction-close" type="button" :disabled="submitting" @click="close">
      <span></span>
      <span></span>
    </button>

    <div class="jwt-satisfaction-header">
      <div class="jwt-satisfaction-title">服务满意度评价</div>
      <div class="jwt-satisfaction-subtitle">您的反馈将帮助我们做得更好</div>
    </div>

    <div class="jwt-satisfaction-body">
      <button
        v-for="item in currentOptions"
        :key="item.value"
        class="jwt-satisfaction-item"
        :class="{ active: selectedValue === item.value, disabled: submitting }"
        type="button"
        :disabled="submitting"
        @click="selectItem(item)"
      >
        <span class="jwt-satisfaction-icon">{{ item.icon }}</span>
        <span class="jwt-satisfaction-label">{{ item.label }}</span>
      </button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SatisfactionDialog",
  data() {
    return {
      dialogVisible: false,
      submitting: false,
      selectedValue: null,
      customerId: null,
      currentOptions: [
        { value: 1, label: "很不满意", icon: "😠" },
        { value: 2, label: "不满意", icon: "🙁" },
        { value: 3, label: "一般", icon: "😐" },
        { value: 4, label: "满意", icon: "😊" },
        { value: 5, label: "很满意", icon: "🤩" }
      ]
    };
  },
  methods: {
    open(option = {}) {
      this.customerId = option.customerId;
      this.selectedValue = null;
      this.submitting = false;
      this.dialogVisible = true;
    },
    selectItem(item) {
      if (this.submitting) {
        return;
      }

      this.selectedValue = item.value;
      this.submitting = true;
      this.$emit("select", item);

      this.$http({
        url: "/customer/addEvaluate",
        method: "POST",
        data: {
          customerId: this.customerId,
          score: item.value
        }
      })
        .then(() => {
          this.$message.success("评价成功");
          this.$emit("success", item);
          setTimeout(() => {
            this.submitting = false;
            this.close();
          }, 500);
        })
        .catch((error) => {
          this.submitting = false;
          this.$emit("error", error);
        });
    },
    close() {
      if (this.submitting) {
        return;
      }

      this.customerId = null;
      this.dialogVisible = false;
    },
    handleClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss">
.jwt-satisfaction-dialog {
  width: 710px !important;
  max-width: calc(100vw - 32px);
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12) !important;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    position: relative;
    padding: 0 !important;
    color: #202124;
  }
}

.jwt-satisfaction-close {
  position: absolute;
  top: 32px;
  right: 40px;
  z-index: 2;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: #d8d8d8;
  cursor: pointer;
  padding: 0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  span {
    position: absolute;
    top: 13px;
    left: 6px;
    width: 16px;
    height: 2px;
    border-radius: 2px;
    background: #111111;

    &:first-child {
      transform: rotate(45deg);
    }

    &:last-child {
      transform: rotate(-45deg);
    }
  }
}

.jwt-satisfaction-header {
  height: 142px;
  border-bottom: 1px solid rgba(0, 82, 217, 0.1);
  background: rgba(0, 82, 217, 0.05);
  text-align: center;
  box-sizing: border-box;
  padding-top: 29px;
}

.jwt-satisfaction-title {
  color: #0052d9;
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
}

.jwt-satisfaction-subtitle {
  margin-top: 32px;
  color: #8b95a5;
  font-size: 16px;
  line-height: 22px;
}

.jwt-satisfaction-body {
  display: flex;
  justify-content: space-between;
  height: 290px;
  padding: 34px 50px 0;
  box-sizing: border-box;
  background: #ffffff;
}

.jwt-satisfaction-item {
  width: 84px;
  height: 118px;
  flex: 0 0 84px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  text-align: center;
  color: #808a99;

  &:hover {
    .jwt-satisfaction-icon {
      box-shadow: 0 0 0 4px rgba(0, 82, 217, 0.08);
    }
  }

  &.active {
    color: #0052d9;

    .jwt-satisfaction-icon {
      border-radius: 12px;
      background: #0052d9;
      box-shadow: 0 0 0 6px rgba(0, 82, 217, 0.1);
    }

    .jwt-satisfaction-label {
      color: #0052d9;
      font-weight: 500;
    }
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.72;
  }
}

.jwt-satisfaction-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto;
  border-radius: 12px;
  background: #f1f3f6;
  font-size: 36px;
  line-height: 1;
  transition: background 0.2s ease, box-shadow 0.2s ease;
}

.jwt-satisfaction-label {
  display: block;
  margin-top: 16px;
  color: #808a99;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
}

@media screen and (max-width: 480px) {
  .jwt-satisfaction-dialog {
    width: calc(100vw - 32px) !important;
  }

  .jwt-satisfaction-close {
    top: 30px;
    right: 36px;
  }

  .jwt-satisfaction-header {
    height: 136px;
    padding-top: 30px;
  }

  .jwt-satisfaction-title {
    font-size: 23px;
    line-height: 32px;
  }

  .jwt-satisfaction-subtitle {
    margin-top: 30px;
    font-size: 15px;
    line-height: 21px;
  }

  .jwt-satisfaction-body {
    height: 191px;
    padding: 32px 18px 0;
    gap: 4px;
  }

  .jwt-satisfaction-item {
    width: auto;
    height: 104px;
    flex: 1 1 0;
    min-width: 0;
  }

  .jwt-satisfaction-icon {
    width: 52px;
    height: 52px;
    font-size: 32px;
  }

  .jwt-satisfaction-label {
    margin-top: 14px;
    font-size: 14px;
    line-height: 20px;
  }
}
</style>
